"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCurrency = void 0;
/**
 * Форматирование числа в цену.
 * @param {number} value
 * @param {string} currency
 * @param {number} minimumFractionDigits
 * @return {string}
 */
exports.formatCurrency = function (value, currency, minimumFractionDigits) {
    var formatter = new Intl.NumberFormat('ru', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
    });
    return formatter.format(value);
};
//# sourceMappingURL=formatCurrency.js.map